import { Input } from "antd"
import type { TOnChangeInput, TOnKeyDown } from "types/default.type"
import { InputNumberBorderlessProvider } from "components/providers/Input.provider"

type Props = {
	inputChangeHandle: (e: TOnChangeInput) => void
	onConfirmHandle: () => void
	value: string | undefined
	placeholder?: string
	onKeyDown?: (e: TOnKeyDown) => void
}

export const InputBorderless = ({ inputChangeHandle, onConfirmHandle, onKeyDown, value, placeholder }: Props) => {
	return (
		<InputNumberBorderlessProvider>
			<div data-testid="input-borderless">
				<Input
					onChange={inputChangeHandle}
					onPressEnter={onConfirmHandle}
					onKeyDown={onKeyDown}
					type="text"
					size="large"
					placeholder={placeholder}
					value={value}
					variant="borderless"
					className="inputBorderless"
					data-testid="inputBorderless"
				/>
			</div>
		</InputNumberBorderlessProvider>
	)
}
